import script from "./PopupContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupContainer.vue?vue&type=script&setup=true&lang=js"

import "./PopupContainer.vue?vue&type=style&index=0&id=5e93f229&lang=scss"

const __exports__ = script;

export default __exports__